import { createFeatureSelector, createSelector } from '@ngrx/store';

import { SeatMapModuleState, seatMapFeatureName } from '@seat-map/store/state/seat-map-module.state';
import { mapSectorAndFlightSelected } from '@seat-map/mappers/seat-map-store.mapper';

export const seatMapRootSelector = createFeatureSelector<SeatMapModuleState>(seatMapFeatureName);

export const selectSectorAndFlightSelected = createSelector(seatMapRootSelector,
  (state: SeatMapModuleState) => mapSectorAndFlightSelected(state.itineraryDetail));

